import React, { useState } from 'react'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import { getApiHeader } from 'utlis/commonfunctions';
import axios from 'axios';
import { Backdrop, CircularProgress } from '@mui/material';
import CustomModal from 'layouts/CommonModal';
import ActivationHead from './ActivationHead';
import Loader from "./loader";


const SERVER_URL = process.env.REACT_APP_API_URL;


function StaffDetails({ nextStep, prevStep, commonSession, handleAccount }) {

    const [isBusinessCustomerConsentChecked, setIsBusinessCustomerConsentChecked] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [staffName,setStaffName] = useState("");

    const handleCheckboxChange = () => {
        setIsBusinessCustomerConsentChecked(!isBusinessCustomerConsentChecked);
        setErrors((prevErrors) => ({ ...prevErrors, consent: '' }));
    };

    const hanldeStaffName = (event) =>{
        const { name, value } = event.target;
        if (/^[a-zA-Z ]{0,50}$/.test(value)) {
            setStaffName(  value );
          }
    }

    const mySubmitHandler = async (event) => {
        event.preventDefault();
        setLoading(true);
    

        if(event.target.staff_name.value === null || event.target.staff_name.value === ''){
            setLoading(false);
            swal("", "Please enter valid staff name.", 'warning');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(event.target.staff_email.value != ""){
        if (!emailRegex.test(event.target.staff_email.value)){
            setLoading(false);
            swal("","Please enter a valid email", 'warning');
            return;
        }
    }
        if (!isBusinessCustomerConsentChecked) {
            setLoading(false);
            swal("", "You must provide consent to proceed. Please check the box to accept.", 'warning');
            return;
        }
        
        const staff_name = event.target.staff_name.value;
        const staff_email = event.target.staff_email.value;
        const session_id = commonSession;
        const headers = await getApiHeader();
        try {
            const response = await axios.post(
                `${SERVER_URL}activation/update/staff/details`,
                {
                    session_id,
                    staff_name,
                    staff_email
                },
                { headers }
            );
            if (response.status === 200) {
                try {
                    const summaryResponse = await axios.post(
                        `${SERVER_URL}activation/get/summery/details`,
                        { session_id },
                        { headers }
                    );
                    console.log('Summary Response:', summaryResponse.data);

                    if(summaryResponse.status===200){
                        handleAccount(summaryResponse.data.data);
                        nextStep();
                    }
                  

                } catch (summaryError) {
                    console.error('Failed to fetch summary details:', summaryError);
                    const apiErrors = summaryError.response.data.message;

                    if (typeof(apiErrors) === 'string') {
                       swal("", apiErrors, 'warning');
                       setLoading(false);
                       return;
                    }else{
                         swal("", "Unexpected error, please try again.", 'warning');
                         setLoading(false);
                    } 
                   
                }
            } else {
               
                swal("", "Unexpected error, please try again.", 'warning');
                setLoading(false);
            }
        } catch (error) {
            if (error.response) {
                 swal("", error.response.data.message, 'warning');
                 setLoading(false);
            } else {
                console.error('Error:', error);
                setLoading(false);
            }
        } finally {
            setLoading(false);
        }
    };



    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <ActivationHead />
                {loading === true && (
                            <Loader />
                )}
                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">
                        <h6>Staff Details</h6>
                        <hr/>
                        <br/>

                        <form onSubmit={mySubmitHandler} className='add-plan-form'>

                        <div className='staff-form'>

                            <div className="formbold-mb-5 formbold-pt-3 col-lg-6">
                                <label className="formbold-form-label formbold-form-label-2">Staff Name <span className="madate_mark">*</span></label>
                                <input
                                    type="text"
                                    name="staff_name"
                                    id="staff_name"
                                    placeholder="Enter Staff Name"
                                    className={`formbold-form-input ${errors.staff_name ? 'is-invalid' : ''}`}
                                    maxLength="50"
                                    value={staffName}
                                    onChange={hanldeStaffName}
                                    autoComplete="new-password"
                                />
                               
                            </div>

                            <div className="formbold-mb-5 formbold-pt-3 col-lg-6">
                                <label className="formbold-form-label formbold-form-label-2">Staff Email Address</label>
                                <input
                                    type="email"
                                    name="staff_email"
                                    id="staff_email"
                                    placeholder="Enter Email Address"
                                    className={`formbold-form-input ${errors.staff_email ? 'is-invalid' : ''}`}
                                    maxLength="50"
                                    autoComplete="new-password"
                                />
                                
                            </div>
                        </div>


                        <div className="formbold-mb-5 formbold-pt-3 col-lg-12">
                            <div className="formbold-mb-5 formbold-pt-3">
                                <div className={`business-customer checkpik ${errors.consent ? 'error-border' : ''}`}>

                                    <label className="check-box">
                                        <input
                                            type="checkbox"
                                            name="business-checkbox"
                                            id="business-checkbox"
                                            checked={isBusinessCustomerConsentChecked}
                                            onChange={handleCheckboxChange}
                                        />
                                    
                                            I consent that I verified with the above customer that his/her personal details are being used for identity verification.<br />
                                            I'm authorized to provide these details and acknowledge that they will be matched to information held by the ID issuer, <br />
                                            the official Government record holder, or Telsim's identification partners.

                                            <span className="tick"></span>
                                    </label>
                                    
                                   

                                </div>
                                
                            </div>
                        </div>
      

                        <div className="button-container activationBlock-button-container">

                            <button type="button" onClick={prevStep} className="button btn btn-danger">
                                Back
                            </button>


                            <button type="submit" className="button btn btn-danger ad-mb-button-next">
                                Next
                            </button>

                        </div>
                        </form>
                     
                    </div>
                </div>
              
            </DashboardLayout>
        </div>
    )
}

export default StaffDetails